import { Skeleton } from '@/components/ui/skeleton';
import { Card, CardContent, CardHeader } from '@/components/ui/card';

/**
 * Skeleton de la JoinPage : 3 cartes (pseudo, intensite, opt-ins) + bouton.
 * Forme = forme finale pour eviter le saut visuel quand la session arrive.
 */
export function JoinSkeleton() {
  return (
    <div className="max-w-lg mx-auto space-y-6" aria-busy="true" aria-live="polite">
      <div className="text-center space-y-2">
        <Skeleton className="h-8 w-56 mx-auto" />
        <Skeleton className="h-4 w-32 mx-auto" />
      </div>

      <Card>
        <CardHeader>
          <Skeleton className="h-5 w-28" />
        </CardHeader>
        <CardContent>
          <Skeleton className="h-10 w-full" />
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <Skeleton className="h-5 w-44" />
          <Skeleton className="h-3 w-72 mt-2" />
        </CardHeader>
        <CardContent className="space-y-3">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-40 mx-auto" />
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <Skeleton className="h-5 w-40" />
          <Skeleton className="h-3 w-72 mt-2" />
        </CardHeader>
        <CardContent className="space-y-3">
          <Skeleton className="h-5 w-3/4" />
          <Skeleton className="h-5 w-3/4" />
          <Skeleton className="h-5 w-3/4" />
        </CardContent>
      </Card>

      <Skeleton className="h-11 w-full" />
      <p className="sr-only">Chargement de la session en cours...</p>
    </div>
  );
}
